import { SdkSnippet } from '../types';

export const getPackageName = (sdk: SdkSnippet) =>
  `${sdk.packageName || ''} ${sdk.packageVersion || ''}${sdk.packageStatus ? ' (' + sdk.packageStatus + ')' : ''}`.trim();
